module.exports = __webpack_public_path__ + "img/z1.887d82dc.png";